export const FoundationSection = ({
    badge = "Start with the right foundation",
    title = "Turn your Databricks investment into a production-ready platform.",
    description = "A proof of concept can demonstrate potential. A platform that remains secure, governed, maintainable, and cost-aware at enterprise scale takes deliberate planning. Mobikode establishes the foundations first, then delivers agreed pipelines, dashboards, or models against real business requirements.",
    imageSrc = "/assets/datab/img1.png",
}) => {
    return (
        <section className="w-full py-[50px] md:py-[70px] bg-white">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                <div className="flex flex-col lg:flex-row items-stretch border border-[#01386A45] overflow-hidden bg-white">
                    <div className="w-full lg:w-full max-w-[498px] min-h-[260px] lg:min-h-[378px] relative bg-[#010B22]">
                        <img
                            src={imageSrc}
                            alt="Enterprise data platform architecture"
                            className="w-full h-full object-cover"
                        />
                    </div>

                    <div className="w-full max-w-[785px] flex flex-col justify-center px-6 sm:px-10 lg:px-16 py-10 lg:py-16">
                        <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora leading-[1.18] tracking-[-0.02em] mb-4 sm:mb-6">
                            {title}
                        </h2>

                        <p className="text-[#01386A] font-graphik text-[14px] md:text-[16px] font-[500] max-w-[560px]">
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FoundationSection;